import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { connect } from "react-redux";
import classes from "./cadastro.module.scss";
import FormComponent from "~/components/Granel/cadastro/Form/Form";
import { Scrollbar, Content, Gradient, ContStepper } from "./styles";
import Stepper from '~/components/layout/Stepper';
import { Link } from 'react-router-dom';
import { MdPlayArrow } from "react-icons/md";


const Cadastro = (props) => {
  
  const [steppers] = React.useState([
      "Sua identificação",
      "Selecione seu e-mail",
      "Selecione seu telefone",
      "Ativação da conta",
      "Concluído"
  ]);

  const { step } = props;

  return (
    <>
    <Scrollbar>
      <Content>
        <Container className={`${classes.container} px-0 mx-0`} fluid>
          <Row className={`${classes.row} px-0 mx-0`}>
            <Col className={`${classes.col} ${classes.colBanner} px-0 mx-0`}>
              <Gradient className={classes.image} >
                <Link to="/" className={classes.logo}>
                  <img alt="Ultragaz Logotipo"  src="/static/ultragaz-logo-blue.svg" />
                </Link>
                <ContStepper>
                  <Stepper activated={step} steppers={steppers} />
                </ContStepper>
              </Gradient>
            </Col>
            <Col className={`${classes.col} ${classes.colText} px-4 mx-0`}>              
              <Card className={`${classes.card} border-0`}>
                <Card.Body className={`first-access-top d-flex flex-column w-100 p-0`}>
                  <h1><MdPlayArrow />&nbsp;&nbsp;Primeiro Acesso</h1>
                  <FormComponent step={step} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
          </Container>
        </Content>
      </Scrollbar>
    </>
  );  
}

const mapStateToProps = state => ({
  step: state.signUpReducer.step
});

export default connect(mapStateToProps)(Cadastro);
